export const VideoTabs = {
  DJP_WEBSITE: 0,
  CORETAX_WEBSITE: 1,
} as const;

export type VideoTabs = (typeof VideoTabs)[keyof typeof VideoTabs];

export const VideoTabMessages = {
  [VideoTabs.DJP_WEBSITE]: {
    contentMessage: {
      id: 'interactive-djp-website-tutorial',
      defaultMessage: 'DJP Website Tutorial',
    },
    headerMessage: {
      id: 'text-how-to-download-djp',
      defaultMessage: 'How to download your company NPWP from DJP website:',
    },
    websiteButton: {
      id: 'interactive-go-to-djp-website',
      defaultMessage: 'Go to DJP Website',
    },
  },
  [VideoTabs.CORETAX_WEBSITE]: {
    contentMessage: {
      id: 'interactive-coretax-website-tutorial',
      defaultMessage: 'Coretax Website Tutorial',
    },
    headerMessage: {
      id: 'text-how-to-download-coretax',
      defaultMessage: 'How to download your company NPWP from Coretax website:',
    },
    websiteButton: {
      id: 'interactive-go-to-coretax-website',
      defaultMessage: 'Go to Coretax Website',
    },
  },
};

export const VideoTutorialStepMessages = {
  [VideoTabs.DJP_WEBSITE]: [
    {
      id: 'text-djp-first-step',
      defaultMessage:
        'Open DJP Website, login to your company account, and go to <bold>Information Tab</bold>',
      image: 'images/tier-verification/image-djp-first-step.jpg',
    },
    {
      id: 'text-djp-second-step',
      defaultMessage:
        'Click <bold>“Send Email”</bold> button to get your NPWP file via email.',
      image: 'images/tier-verification/image-djp-second-step.jpg',
    },
    {
      id: 'text-djp-third-step',
      defaultMessage:
        'You can check the <bold>NPWP file in your email</bold>, and download it to get your PDF file.',
      image: 'images/tier-verification/image-djp-third-step.jpg',
    },
  ],
  [VideoTabs.CORETAX_WEBSITE]: [
    {
      id: 'text-coretax-first-step',
      defaultMessage:
        'Open Coretax Website, login to your company account, and go to <bold>My Documents</bold> under <bold>My Portal</bold>.',
      image: 'images/tier-verification/image-coretax-first-step.jpg',
    },
    {
      id: 'text-coretax-second-step',
      defaultMessage:
        'Click <bold>“Refresh”</bold> to fetch your documents including NPWP. If NPWP isn’t listed, click <bold>“Produce Document”</bold> and search again.',
      image: 'images/tier-verification/image-coretax-second-step.jpg',
    },
    {
      id: 'text-coretax-third-step',
      defaultMessage:
        'When you find the NPWP document in the table, <bold>download it right away</bold> to get your PDF file.',
      image: 'images/tier-verification/image-coretax-third-step.jpg',
    },
  ],
};

export const VideoTutorialModalLinks = {
  [VideoTabs.CORETAX_WEBSITE]: {
    videoLink: 'https://youtu.be/TGXImhuOI6I',
    websiteLink: 'https://coretaxdjp.pajak.go.id',
  },
  [VideoTabs.DJP_WEBSITE]: {
    videoLink: 'https://youtu.be/njcZbciPl7k',
    websiteLink: 'https://djponline.pajak.go.id',
  },
};
